module.exports = __webpack_public_path__ + "img/07_shimizu_12.cc15ce16.jpg";